module.exports = __webpack_public_path__ + "static/img/first.b59e628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/first.png
// module id = O7ST
// module chunks = 2